import {
	TLocationDealerCodeState,
	TAction,
	EActionType,
	IUpdateOemAction,
	IUpdateAreaAction,
} from "@/Settings/types/administrationTools/locationDealerCodes";
import { updateFranchiseArea } from "./utils";

const initialFranchise = {
	dealerCode: "",
	franchise: "",
	groups: [],
	isCombined: false,
};

const initialOem = {
	oemName: "",
	oemReference: "",
	version: "",
	financialStatementVersion: "",
	dealerCodeFS: "",
	legalName: "",
	dba: "",
	franchises: [initialFranchise],
};

export const initialOemState: TLocationDealerCodeState = [initialOem];

export const formReducer = (state: TLocationDealerCodeState, action: TAction) => {
	const { oemIndex, franchiseIndex, ...payload } = action.payload;
	switch (action.type) {
		case EActionType.UPDATE_STATE:
			return action.newState;
		case EActionType.UPDATE_OEM:
			return state.map((location, index) =>
				index === oemIndex
					? {
							...location,
							...payload,
							franchises: (payload as IUpdateOemAction).oemReference ? [initialFranchise] : location.franchises,
					  }
					: location
			);
		case EActionType.ADD_OEM:
			return [...state, initialOem];
		case EActionType.DELETE_OEM:
			return state.filter((_, index) => index !== oemIndex);
		case EActionType.UPDATE_FRANCHISE:
			return state.map((location, stateIndex) =>
				stateIndex === oemIndex
					? {
							...location,
							franchises: location.franchises.map((franchise, index) =>
								index === franchiseIndex ? { ...franchise, ...payload } : franchise
							),
					  }
					: location
			);
		case EActionType.ADD_FRANCHISE:
			return state.map((location, stateIndex) =>
				stateIndex === oemIndex
					? {
							...location,
							franchises: [...location.franchises, initialFranchise],
					  }
					: location
			);
		case EActionType.DELETE_FRANCHISE:
			return state.map((location, stateIndex) =>
				stateIndex === oemIndex
					? {
							...location,
							franchises: location.franchises.filter((_, index) => index !== franchiseIndex),
					  }
					: location
			);
		case EActionType.UPDATE_AREA:
			return state.map((location, stateIndex) =>
				stateIndex === oemIndex
					? {
							...location,
							franchises: location.franchises.map((franchise, index) =>
								index === franchiseIndex
									? { ...franchise, area: updateFranchiseArea((payload as IUpdateAreaAction).area, franchise.area) }
									: franchise
							),
					  }
					: location
			);
		default:
			return state;
	}
};
